<template>
  <footer
    class="footer footer-default"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <div class="row justify-content-md-center sharing-area text-center">
        <div class="text-center col-md-12 col-lg-8">
          <h3>Contáctanos</h3>
        </div>
        <div class="text-center col-md-12 col-lg-8">
          <a
            target="_blank"
            href="#"
            class="btn btn-neutral btn-icon btn-twitter btn-round btn-lg"
            rel="tooltip"
            title="Social Net1"
          >
            <i class="fab fa-twitter"></i>
          </a>
          <a
            target="_blank"
            href="#"
            class="btn btn-neutral btn-icon btn-facebook btn-round btn-lg"
            rel="tooltip"
            title="Social Net2"
          >
            <i class="fab fa-facebook-square"></i>
          </a>
          <a
            target="_blank"
            href="#"
            class="btn btn-neutral btn-icon btn-linkedin btn-lg btn-round"
            rel="tooltip"
            title="Social Net3"
          >
            <i class="fab fa-linkedin"></i>
          </a>
          <a
            target="_blank"
            href="#"
            class="btn btn-neutral btn-icon btn-github btn-round btn-lg"
            rel="tooltip"
            title="Social Net4"
          >
            <i class="fab fa-google-plus"></i>
          </a>
        </div>
      </div>
      <nav>
        <ul>
          <li>
            <a href="#">
              Términos y Condiciones
            </a>
          </li>
          <li>
            <a href="#">
              Políticas de uso
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, Mollusca
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
